// Espejo de server/utils/annualPlanStatus.js — mismo criterio, para previsualizar
// el Estado del Plan Anual en el cliente antes de guardar.
export function computeAnnualPlanStatus(progress, fechaProgramada, now = new Date()) {
  const pct = Number(progress) || 0;

  if (pct >= 100) return "completed";

  if (fechaProgramada && new Date(fechaProgramada) < now) return "overdue";

  if (pct > 0) return "in_progress";

  return "pending";
}

// Plan Anual usa "No iniciado" en vez de "Pendiente" para progreso 0%,
// y solo admite estos 4 valores (se calculan, no se eligen a mano).
export const AP_STATUS_LABEL = {
  pending:     "No iniciado",
  in_progress: "En progreso",
  completed:   "Realizado",
  overdue:     "Vencido",
};
